var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task_alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.8337 4.31675L9.32533 13.8334L5.79199 10.3001L6.96699 9.12508L9.32533 11.4834L17.6587 3.15008L18.8337 4.31675ZM16.992 8.51675C17.1003 8.99175 17.167 9.49175 17.167 10.0001C17.167 13.6834 14.1837 16.6667 10.5003 16.6667C6.81699 16.6667 3.83366 13.6834 3.83366 10.0001C3.83366 6.31675 6.81699 3.33341 10.5003 3.33341C11.817 3.33341 13.0337 3.71675 14.067 4.37508L15.267 3.17508C13.917 2.22508 12.2753 1.66675 10.5003 1.66675C5.90033 1.66675 2.16699 5.40008 2.16699 10.0001C2.16699 14.6001 5.90033 18.3334 10.5003 18.3334C15.1003 18.3334 18.8337 14.6001 18.8337 10.0001C18.8337 9.00842 18.6503 8.05841 18.3337 7.17508L16.992 8.51675Z",
    fill: "#98CB65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskComplete);
export default __webpack_public_path__ + "static/media/task-complete.0d8d9343283856b6d4174673e005b758.svg";
export { ForwardRef as ReactComponent };